import React from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import { useHtmlToPng } from './useHtmlToPng';

export const EttiketLarge = (props) => {
  const {
    foodName = 'Ilchard Puttanesca',
    id = 52837,
    category = 'Pasta',
    area = 'Italy',
    description = 'cook :]',
    ingridients = ['Spaghettig', 'Olive Oil'],
    measure = ['300g', '1 tbls'],
  } = props;

  const [generateImage, appRef, imageUrl, isLoading] = useHtmlToPng(2048);

  if (!isLoading) {
    return (
      <Redirect
        push
        to={{
          pathname: '/boxlarge',
          state: { imageUrl: imageUrl },
        }}
      />
    );
  } else {
    return (
      <>
        <Container ref={appRef}>
          <Front>
            <Hero />
            <Description>
              <FoodName>{foodName}</FoodName>
              <DescriptionContainer>
                <h2>#{id}</h2>
                <h3>
                  <span>Category: </span>
                  <span>{category}</span>
                </h3>
                <h3>
                  <span>Area: </span>
                  <span>{area}</span>
                </h3>
                <p>{description}</p>
              </DescriptionContainer>
            </Description>
          </Front>
          <Back>
            <Hero />
            <Description>
              <FoodName>{foodName}</FoodName>
              <IngridientsContainer>
                <h2>#{id}</h2>
                <h3>Ingriedients</h3>
                <List>
                  <Ingridients>
                    {ingridients.map((item, index) => (
                      <li key={item + index}>{item}</li>
                    ))}
                  </Ingridients>
                  <Measure>
                    {measure.map((item, index) => (
                      <li key={item + index}>{item}</li>
                    ))}
                  </Measure>
                </List>
              </IngridientsContainer>
            </Description>
          </Back>
        </Container>
        <FullScreenLoader generateImage={generateImage} />
      </>
    );
  }
};

const Hero = () => (
  <HeroContainer>
    <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M161.384 230.106C156.308 217.246 149.683 205.05 141.654 193.785C135.152 184.796 127.701 174.72 117.655 169.405C113.275 167.126 108.424 165.892 103.485 165.8C98.5454 165.709 93.6522 166.761 89.19 168.876C83.2932 171.94 78.6247 176.923 75.9596 182.998C73.2945 189.074 72.7932 195.876 74.5391 202.274C80.2599 220.81 103.115 228.993 119.915 233.78C136.715 238.567 155.831 242.965 172.631 237.482C180.787 234.907 188.129 230.253 193.929 223.981C199.729 217.708 203.786 210.034 205.7 201.718C212.084 177.523 212.657 152.169 207.374 127.712C205.225 117.72 202.993 106.643 196.77 98.2657C191.173 90.908 183.494 85.3919 174.724 82.4293C169.467 80.6098 163.878 79.944 158.339 80.4772C152.8 81.0103 147.442 82.73 142.631 85.5186C136.932 88.9436 132.3 93.8799 129.25 99.7772C126.2 105.674 124.852 112.301 125.357 118.917C126.724 139.819 143.524 157.019 161.97 165.341C172.948 169.801 184.245 173.438 195.765 176.223C207.765 179.619 219.932 182.179 232.044 185.575C239.392 187.633 246.606 190.143 253.643 193.09V179.675C246.123 182.417 239.565 187.282 234.769 193.677C229.972 200.072 227.144 207.72 226.63 215.689C226.423 223.048 228.66 230.269 232.992 236.229C238.011 243.676 244.051 250.383 250.936 256.157C252.265 257.418 254.028 258.121 255.862 258.121C257.696 258.121 259.459 257.418 260.787 256.157C262.084 254.849 262.812 253.084 262.812 251.245C262.812 249.405 262.084 247.64 260.787 246.332C255.326 241.806 250.443 236.627 246.248 230.913C244.524 228.609 243.02 226.149 241.755 223.566C240.796 221.594 240.373 219.406 240.527 217.22C240.724 212.26 242.278 207.447 245.02 203.304C247.907 198.67 252.241 195.11 257.355 193.173C264.22 190.696 263.662 182.402 257.355 179.758C245.339 174.914 232.931 171.096 220.267 168.347C209.579 165.842 199.086 162.78 188.509 159.802C179.436 157.695 170.688 154.382 162.5 149.95C153.52 144.855 144.562 136.349 141.04 126.515C139.396 121.925 138.911 117.221 139.645 112.404C140.454 107.138 143.237 102.373 147.431 99.0729C150.267 96.856 153.599 95.3568 157.142 94.7032C165.996 92.7057 173.828 95.2701 181.198 101.689C186.825 106.59 191.215 115.307 193.88 128.601C197.287 145.588 197.891 154.728 196.379 173.273C195.897 179.915 194.965 186.517 193.588 193.034C192.685 197.178 191.661 201.545 189.877 205.419C187.615 209.917 184.982 213.582 181.142 216.858C175.186 222.101 167.62 224.999 159.766 225.625C157.349 225.751 154.927 225.751 152.51 225.625C146.936 225.314 141.399 224.522 135.961 223.26C122.008 220.198 108.25 216.496 96.6411 208.453C94.5785 207.07 92.7357 205.378 91.1156 203.499C90.1043 202.378 89.3758 201.102 88.6598 199.769C87.658 197.891 87.3291 195.099 87.711 192.811C87.9755 190.637 88.7055 188.546 89.8514 186.678C90.9973 184.81 92.5324 183.209 94.3527 181.985C98.1209 179.993 102.214 179.367 106.353 180.148C108.746 180.727 109.92 181.13 111.99 182.402C115.766 184.984 119.158 188.085 122.064 191.615C128.842 199.371 134.747 207.846 139.673 216.886C142.749 222.413 145.489 228.12 147.877 233.975C148.841 236.337 149.613 237.2 151.21 238.105C152.806 239.01 154.688 239.274 156.473 238.846C158.249 238.339 159.754 237.156 160.662 235.552C161.748 233.635 162.016 231.708 161.384 230.106Z"
        fill="black"
      />
      <path
        d="M350.616 230.106C355.692 217.246 362.317 205.05 370.346 193.785C376.848 184.796 384.299 174.72 394.345 169.405C398.725 167.126 403.576 165.892 408.515 165.8C413.455 165.709 418.348 166.761 422.81 168.876C428.707 171.94 433.375 176.923 436.04 182.998C438.705 189.074 439.207 195.876 437.461 202.274C431.74 220.81 408.885 228.993 392.085 233.78C375.285 238.567 356.169 242.965 339.369 237.482C331.213 234.907 323.871 230.253 318.071 223.981C312.271 217.708 308.214 210.034 306.3 201.718C299.916 177.523 299.343 152.169 304.626 127.712C306.775 117.72 309.007 106.643 315.23 98.2657C320.827 90.908 328.506 85.3919 337.276 82.4293C342.533 80.6098 348.122 79.944 353.661 80.4772C359.2 81.0103 364.558 82.73 369.369 85.5186C375.068 88.9436 379.7 93.8799 382.75 99.7772C385.8 105.674 387.148 112.301 386.643 118.917C385.276 139.819 368.476 157.019 350.03 165.341C339.052 169.801 327.755 173.438 316.235 176.223C304.235 179.619 292.068 182.179 279.956 185.575C272.608 187.633 265.394 190.143 258.357 193.09V179.675C265.877 182.417 272.435 187.282 277.231 193.677C282.028 200.072 284.856 207.72 285.37 215.689C285.577 223.048 283.34 230.269 279.008 236.229C273.989 243.676 267.949 250.383 261.064 256.157C259.735 257.418 257.972 258.121 256.138 258.121C254.304 258.121 252.541 257.418 251.213 256.157C249.916 254.849 249.188 253.084 249.188 251.245C249.188 249.405 249.916 247.64 251.213 246.332C256.674 241.806 261.557 236.627 265.752 230.913C267.476 228.609 268.98 226.149 270.245 223.566C271.204 221.594 271.627 219.406 271.473 217.22C271.276 212.26 269.722 207.447 266.98 203.304C264.093 198.67 259.759 195.11 254.645 193.173C247.78 190.696 248.338 182.402 254.645 179.758C266.661 174.914 279.069 171.096 291.733 168.347C302.421 165.842 312.914 162.78 323.491 159.802C332.564 157.695 341.312 154.382 349.5 149.95C358.48 144.855 367.438 136.349 370.96 126.515C372.604 121.925 373.089 117.221 372.355 112.404C371.546 107.138 368.763 102.373 364.569 99.0729C361.733 96.856 358.401 95.3568 354.858 94.7032C346.004 92.7057 338.172 95.2701 330.802 101.689C325.175 106.59 320.785 115.307 318.12 128.601C314.713 145.588 314.109 154.728 315.621 173.273C316.103 179.915 317.035 186.517 318.412 193.034C319.315 197.178 320.339 201.545 322.123 205.419C324.385 209.917 327.018 213.582 330.858 216.858C336.814 222.101 344.38 224.999 352.234 225.625C354.651 225.751 357.073 225.751 359.49 225.625C365.064 225.314 370.601 224.522 376.039 223.26C389.992 220.198 403.75 216.496 415.359 208.453C417.421 207.07 419.264 205.378 420.884 203.499C421.896 202.378 422.624 201.102 423.34 199.769C424.342 197.891 424.671 195.099 424.289 192.811C424.025 190.637 423.295 188.546 422.149 186.678C421.003 184.81 419.468 183.209 417.647 181.985C413.879 179.993 409.786 179.367 405.647 180.148C403.254 180.727 402.08 181.13 400.01 182.402C396.234 184.984 392.842 188.085 389.936 191.615C383.158 199.371 377.253 207.846 372.327 216.886C369.251 222.413 366.511 228.12 364.123 233.975C363.159 236.337 362.387 237.2 360.79 238.105C359.194 239.01 357.312 239.274 355.527 238.846C353.751 238.339 352.246 237.156 351.338 235.552C350.252 233.635 349.984 231.708 350.616 230.106Z"
        fill="black"
      />
      <path
        d="M194.814 364.148C188.216 374.574 181.167 386.57 180.942 399.322C180.78 408.196 183.776 416.841 189.401 423.734C197.86 433.515 211.394 433.823 222.476 428.778C242.213 419.894 246.274 397.276 243.933 378.021C242.101 362.999 237.956 346.968 228.735 334.636C217.054 319.473 200.121 309.164 181.224 305.712C173.936 304.205 166.452 303.883 159.061 304.759C145.808 306.413 133.514 311.71 121.39 317.007C109.749 321.936 99.1353 328.979 90.0913 337.775C82.3936 345.426 76.9234 353.638 75.6263 364.485C74.8622 370.337 75.4841 376.286 77.4422 381.858C79.4004 387.429 82.6407 392.469 86.905 396.575C91.111 400.222 96.0337 402.96 101.361 404.615C106.688 406.271 112.303 406.807 117.85 406.19C123.397 405.573 128.754 403.817 133.581 401.033C138.409 398.249 142.602 394.498 145.893 390.017C151.184 382.707 154.838 374.354 156.608 365.521C162.247 337.494 160.64 308.683 156.608 280.46C155.593 273.313 154.437 266.194 153.224 259.047L144.568 267.679C171.947 272.388 205.163 267.679 220.304 241.698C224.844 233.879 212.663 226.816 208.123 234.635C196.309 254.927 168.648 257.646 148.318 254.254C147.121 253.958 145.867 253.975 144.679 254.302C143.49 254.629 142.406 255.255 141.533 256.121C140.659 256.986 140.026 258.061 139.693 259.242C139.36 260.422 139.339 261.668 139.633 262.859C143.722 287.214 147.19 311.766 145.949 336.514C145.103 353.33 143.722 375.527 129.595 387.27C117.47 397.332 95.2795 392.876 90.4297 376.648C89.3223 372.894 89.0339 368.947 89.5837 365.073C90.3306 360.963 90.7688 359.512 92.5726 356.665C98.4433 348.076 106.256 340.974 115.384 335.925C124.886 330.379 134.94 325.823 145.385 322.332C154.301 319.062 163.831 317.78 173.3 318.576C177.369 318.918 181.454 319.999 185.34 321.183C192.658 323.334 199.546 326.728 205.698 331.216C217.146 339.625 223.603 351.928 227.1 365.297C228.837 371.528 229.886 377.928 230.23 384.384C230.401 387.889 230.306 391.402 229.948 394.894C229.531 398.489 228.581 402.002 227.128 405.32C225.513 408.82 223.006 411.841 219.856 414.082C216.706 416.324 213.021 417.709 209.167 418.1C201.215 418.577 197.437 412.271 195.801 406.301C193.433 397.893 196.422 389.933 200.397 382.366C204.903 373.691 210.268 365.486 216.413 357.87C220.22 353.218 224.28 348.733 228.482 344.417C234.798 337.943 224.111 328.747 218.5 334.524C216.446 336.638 202.963 351.272 194.814 364.148Z"
        fill="black"
      />
      <path
        d="M317.185 364.148C323.783 374.574 330.833 386.57 331.058 399.322C331.22 408.196 328.224 416.841 322.599 423.734C314.14 433.515 300.606 433.823 289.524 428.778C269.786 419.894 265.726 397.276 268.066 378.021C269.899 362.999 274.044 346.968 283.264 334.636C294.946 319.473 311.879 309.164 330.776 305.712C338.063 304.205 345.548 303.883 352.939 304.759C366.191 306.413 378.485 311.71 390.61 317.007C402.25 321.936 412.864 328.979 421.908 337.775C429.606 345.426 435.076 353.638 436.373 364.485C437.138 370.337 436.516 376.286 434.558 381.858C432.599 387.429 429.359 392.469 425.095 396.575C420.889 400.222 415.966 402.96 410.639 404.615C405.312 406.271 399.697 406.807 394.15 406.19C388.603 405.573 383.246 403.817 378.418 401.033C373.591 398.249 369.398 394.498 366.107 390.017C360.816 382.707 357.162 374.354 355.392 365.521C349.753 337.494 351.36 308.683 355.392 280.46C356.407 273.313 357.563 266.194 358.776 259.047L367.432 267.679C340.053 272.388 306.837 267.679 291.695 241.698C287.156 233.879 299.337 226.816 303.876 234.635C315.691 254.927 343.352 257.646 363.682 254.254C364.879 253.958 366.132 253.975 367.321 254.302C368.51 254.629 369.593 255.255 370.467 256.121C371.34 256.986 371.974 258.061 372.307 259.242C372.64 260.422 372.66 261.668 372.367 262.859C368.278 287.214 364.81 311.766 366.05 336.514C366.896 353.33 368.278 375.527 382.405 387.27C394.529 397.332 416.72 392.876 421.57 376.648C422.677 372.894 422.966 368.947 422.416 365.073C421.669 360.963 421.231 359.512 419.427 356.665C413.556 348.076 405.744 340.974 396.616 335.925C387.113 330.379 377.059 325.823 366.614 322.332C357.699 319.062 348.169 317.78 338.7 318.576C334.631 318.918 330.546 319.999 326.659 321.183C319.341 323.334 312.453 326.728 306.301 331.216C294.853 339.625 288.396 351.928 284.9 365.297C283.163 371.528 282.114 377.928 281.77 384.384C281.599 387.889 281.693 391.402 282.052 394.894C282.469 398.489 283.419 402.002 284.872 405.32C286.487 408.82 288.994 411.841 292.144 414.082C295.294 416.324 298.979 417.709 302.833 418.1C310.785 418.577 314.563 412.271 316.198 406.301C318.567 397.893 315.578 389.933 311.602 382.366C307.097 373.691 301.732 365.486 295.587 357.87C291.78 353.218 287.72 348.733 283.518 344.417C277.202 337.943 287.889 328.747 293.5 334.524C295.553 336.638 309.036 351.272 317.185 364.148Z"
        fill="black"
      />
    </svg>
    <h1>Apollo Foods</h1>
  </HeroContainer>
);

const FullScreenLoader = ({ generateImage }) => (
  <Loader>
    <h1>Rendering in the background</h1>
    <button onClick={(e) => generateImage(e)}>Capture</button>
  </Loader>
);

const Loader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--blue-50);
  display: grid;
  place-items: center;
  z-index: 10;
`;

const HeroContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
  svg {
    max-width: 180px;
    max-height: 180px;
  }

  h1 {
    margin: 0;
    font-size: 64px;
  }
`;

const Container = styled.div`
  box-sizing: border-box;
  * {
    font-family: Blatant;
    font-weight: normal;
    box-sizing: border-box;
  }

  position: relative;
  top: 0;
  left: 0;
  width: 2048px;
  height: 2048px;
  background-color: var(--orange-50);

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 120px;
  padding: 820px 48px 0;
`;

const Front = styled.div`
  grid-column: span 1;
  height: 910px;
  background-color: white;
  border-radius: 25px;

  padding: 0 24px 36px;
`;

const Back = styled(Front)``;

const Description = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DescriptionContainer = styled.div`
  min-width: 620px;
  width: 90%;
  background: white;
  border: 9px solid var(--orange-50);
  box-sizing: border-box;
  padding: 16px 8px;

  h3,
  h2,
  p {
    margin: 0;
  }
  h2 {
    margin-bottom: 8px;
    font-size: 48px;
  }
  h3 {
    font-size: 32px;
  }

  p {
    margin-top: 24px;
    font-size: 24px;
    font-size: clamp(1.5rem, 8vw - 2rem, 3rem);
  }
`;

const FoodName = styled.h2`
  font-size: 48px;
  width: fit-content;
  padding: 16px 32px;
  margin: 0 0 32px;
  background: linear-gradient(
    91.47deg,
    #f93406 0%,
    #594ab6 51.56%,
    #00c6ff 100%
  );
  border-radius: 96px;
  color: white;
`;

const IngridientsContainer = styled(DescriptionContainer)``;
const List = styled.div`
  display: flex;
  font-size: clamp(1.5rem, 8vw - 2rem, 3rem);
`;

const Ingridients = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;
const Measure = styled(Ingridients)`
  display: flex;
  flex-direction: column;
  list-style: none;
`;
